export default __webpack_public_path__ + "static/media/test1.9533c44f.jpg";